module.exports = __webpack_public_path__ + "static/MFA-44858ce5825e1862d276b2b2921d037e.png";